import {IonGrid, IonRow, IonCol, IonModal, IonButtons, IonButton, IonIcon, IonContent, IonHeader, IonToolbar, IonTitle, useIonRouter, IonText, IonCardHeader, IonCardTitle, IonCardContent, IonCardSubtitle} from "@ionic/react";
import {checkmarkOutline, chevronBack, scan} from "ionicons/icons";
import {QrReader} from "react-qr-reader";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;
import {OnResultFunction} from "react-qr-reader/src/types";
import CustomField from "../components/CustomField";
import {useFormInput, validateForm} from "../_/useForms";
import React, {useEffect, useState} from "react";
import indexBy from "underscore/modules/indexBy";
import styles_Modal_2_1 from './Modal_2_1.module.scss';
import {push_pg_0_24__VenderRedeem} from "../store/Pg_2_Store";
import {handleCommonFetchErrors} from "./Utils";
import {Pg_8_5_Store, push_pg_8_5__generateregisterticket, push_pg_8_5__scan} from "../store/Pg_8_Store";
import {useStoreState} from "pullstate";
import {getPageData} from "../store/Selectors";


export const useLoginFields = () => {
    return [
        {
            id: "create_phone",
            label: "手機號",
            required: false,
            input: {
                props: {
                    type: "text",
                    placeholder: "手機號 ( 台灣手機免打國際碼，開頭為0 )",
                    autocomplete: "false"
                },
                state: useFormInput("")
            }
        },
    ];
}

export const Modal_8_5_CreateTicketCode = ({tokenEnwId, dismiss, onResult}) => {
    const router = useIonRouter();
    let [mode, setMode] = useState(1);
    const pgData = useStoreState(Pg_8_5_Store, getPageData);

    //#region Back button
    useEffect(() => {
        let callback: any = (ev) => {
            // ev.detail.register(10, () => {
            //     console.log('Handler was called!');
            // });

            dismiss();
        };

        document.addEventListener('ionBackButton', callback);
        // Remove listener on unmount
        return () => document.removeEventListener("ionBackButton", callback);
    }, []);
    //#endregion


    const fields = useLoginFields();
    let keyedFields = indexBy(fields, 'id');


    const [errors, setErrors] = useState(false);

    const handleScan = result => {
        if (result) {
            //setQRData(result);
            //play();
            //handleSuccess(result);
            alert(`代碼: ${result.text}`);
            keyedFields.code.input.state.reset(result.text);
            //onResult(result);
        }
    }

    const _push_createticketcode = async () => {
        const errors = validateForm(fields);
        setErrors(errors);

        if (!errors.length) {
            const create_phone = fields && (keyedFields.create_phone as any).input.state.value;
            let error: any = null;
            let payload: any = null;
            if ({error, payload} = (await push_pg_8_5__generateregisterticket({
                create_phone: create_phone,
            }))) {
                if (error) { //沒有成功被net處理
                    if (!handleCommonFetchErrors(router, error)) {
                        dismiss();
                        if (onResult) {
                            onResult(false);
                        }
                    } else {
                        dismiss();
                    }
                } else if (error === null) { //successfully received a value from net
                    onResult(payload);
                }
            }

        }
    }


    return <>
        <IonHeader>
            <IonToolbar>
                <IonTitle>透過訪客填表建立帳號</IonTitle>
                <IonButtons slot="start">
                    <IonButton onClick={dismiss}>
                        <IonIcon size="large" icon={chevronBack} style={{marginLeft: "-0.7rem"}}/>
                    </IonButton>
                </IonButtons>
            </IonToolbar>
        </IonHeader>

        <IonContent fullscreen>


            <IonGrid>
                <div className="ion-padding">
                    <p>
                        1. 輸入訪客電話號碼，系統確保無重複，將產生專屬網址連結供訪客使用。
                    </p>
                    <p>
                        2. 連結可透過 "SMS 將該連結傳送給訪客" 或 "現場展示 QRCode" 給訪客掃描。
                    </p>
                    <p>
                        3. 訪客可多次填表，但不能改指定電話號碼，且一個電話只能註冊一個帳號。
                    </p>
                </div>

                <IonCardHeader>
                    <IonCardTitle>產生簡易註冊連結</IonCardTitle>
                    <IonCardSubtitle>請提供必要資訊</IonCardSubtitle>
                </IonCardHeader>
                <IonCardContent>

                    <IonRow>
                        <IonCol>
                            {fields.map((f: any) => {
                                return <CustomField key={f.id} field={f} errors={errors} noLabelSlot={false}/>
                            })}
                        </IonCol>
                    </IonRow>
                    {/*確定建立連結*/}

                {/*    onClick={(e) => {*/}
                {/*    e.preventDefault();*/}
                {/*    e.stopPropagation();*/}

                {/*    _push_createticketcode();*/}

                {/*    return false;*/}
                {/*}}*/}

                    <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">
                        <IonCol>
                            <IonButton fill={"solid"} >
                                暫不開放
                            </IonButton>
                        </IonCol>
                    </IonRow>


                </IonCardContent>

                {/*<IonRow className="ion-text-center ion-margin-top" >*/}
                {/*    <IonCol size="12">*/}
                {/*        <IonIcon style={{ fontSize: "5rem" }} icon={ props.modalOptions.icon } />*/}
                {/*    </IonCol>*/}
                {/*</IonRow>*/}

                <IonRow className="ion-justify-content-center">
                    <IonCol>

                    </IonCol>
                </IonRow>

                {/*<IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">*/}
                {/*    <IonCol>*/}
                {/*        <IonButton fill={"solid"}>*/}
                {/*            兌換*/}
                {/*        </IonButton>*/}
                {/*    </IonCol>*/}
                {/*</IonRow>*/}


                {/*{mode === 1 &&*/}
                {/*    <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">*/}
                {/*        <IonCol>*/}
                {/*            <IonButton fill={"solid"} onClick={(e) => {*/}
                {/*                e.preventDefault();*/}
                {/*                e.stopPropagation();*/}

                {/*                setMode(2);*/}

                {/*                return false;*/}
                {/*            }}>*/}
                {/*                打開掃描*/}
                {/*            </IonButton>*/}
                {/*        </IonCol>*/}
                {/*    </IonRow>*/}
                {/*}*/}
            </IonGrid>
        </IonContent>
    </>;
};
